import * as React from 'react';

import * as iconStyles from './icon-styles.less';

export const TickIcon = () => (
	<div className={iconStyles.tickContainer}>
		<div className={iconStyles.tick} />
	</div>
);
